export default "__VITE_ASSET__CCBiFk_3__"